module.exports = __webpack_public_path__ + "media/images/mastercard-ae91cf58.png";